import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { EControlType } from '@cian/frontend-newbuilding-carousel-component';
import { SLIDER_FIRST_PAINT, SLIDER_MEDIA } from '../constants';

function getDefaultControls(defaultControls) {
  return defaultControls || [{
    type: EControlType.ARROWS
  }];
}

export function prepareSliderOptions(_ref) {
  var defaultControls = _ref.defaultControls;
  var media = [_objectSpread(_objectSpread({}, SLIDER_MEDIA), {}, {
    settings: _objectSpread(_objectSpread({}, SLIDER_MEDIA.settings), {}, {
      defaultControls: getDefaultControls(defaultControls)
    })
  })];

  var firstPaintOptions = _objectSpread(_objectSpread({}, SLIDER_FIRST_PAINT), {}, {
    defaultControls: getDefaultControls(defaultControls)
  });

  return {
    media: media,
    firstPaintOptions: firstPaintOptions
  };
}